import { FC } from "react";
import { Heading } from "@chakra-ui/react";
import { Highlight } from "~/components";
import { Trans } from "~/utils/i18next";

const reddishComponents = {
  Highlight: (
    <Highlight
      fontWeight="bold"
      highlightColor="var(--chakra-colors-newReddish-50)"
    />
  ),
};

const peachishComponents = {
  Highlight: (
    <Highlight
      fontWeight="bold"
      highlightColor="var(--chakra-colors-newPeach-300)"
    />
  ),
};

const blueComponents = {
  Highlight: (
    <Highlight
      fontWeight="bold"
      highlightColor="var(--chakra-colors-newBlue-100)"
    />
  ),
};

const componentsByHighlightColor = {
  "var(--chakra-colors-newReddish-50)": reddishComponents,
  "var(--chakra-colors-newPeach-300)": peachishComponents,
  "var(--chakra-colors-newBlue-100)": blueComponents,
};

type HighlightColor =
  | "var(--chakra-colors-newReddish-50)"
  | "var(--chakra-colors-newPeach-300)"
  | "var(--chakra-colors-newBlue-100)";

interface Props {
  highlightColor: HighlightColor;
  i18nKey:
    | "onboarding.welcomePage.heading.desktop"
    | "onboarding.welcomePage.heading.mobile"
    | "onboarding.welcomeNamePage.heading";
}

export const HeadingWithHighlight: FC<Props> = ({
  highlightColor,
  i18nKey,
}) => {
  const components = componentsByHighlightColor[highlightColor];

  return (
    <Heading
      lineHeight={{ base: "1.4", md: "1.2" }}
      textAlign="center"
      variant="th-h3"
    >
      <Trans components={components} i18nKey={i18nKey} />
    </Heading>
  );
};
